"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GoogleGmail = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09 14.1h2.546V7.918L0 5.191v7.818c0 .604.49 1.091 1.09 1.091Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.363 14.1h2.546c.603 0 1.09-.49 1.09-1.09V5.19l-3.636 2.728",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.363 3.19v4.728L16 5.191V3.736c0-1.349-1.54-2.118-2.618-1.309",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.637 7.918V3.191L8 6.464l4.364-3.273v4.727L8 11.191",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.736v1.455l3.636 2.727V3.191l-1.018-.764C1.538 1.618 0 2.387 0 3.737Z",
    fill: "#C5221F"
  })));
});
var _default = GoogleGmail;
exports["default"] = _default;